import type { ContentPage } from "@/lib/content/types";

// CRM › CRM Analytics › Reports (leaf).
export const reports: ContentPage = {
  slug: "crm-analytics/reports",
  template: "hrmsFeature",
  seo: {
    title: "CRM Reports - Build Custom Sales Reports | GetBiz CRM",
    description: "Build custom CRM reports on leads, deals, activity and revenue with GetBiz CRM. Filter, group and schedule reports without spreadsheets.",
    keywords: ["crm reports", "sales reports", "custom crm reporting", "sales reporting software"],
    ogImage: "/assets/data/seoimages/reports.webp",
  },
  leaf: {
    hero: {
      caption: "Reports",
      title: "Build Any Sales Report in Minutes",
      description: "Create, filter and schedule reports on leads, deals, activity and revenue — no spreadsheets, no waiting on IT.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Reports",
      bullets: [
        { title: "Custom Reports", description: "Report on any field or object with drag-and-drop filters." },
        { title: "Scheduled Delivery", description: "Email reports to stakeholders automatically on a schedule." },
        { title: "Drill-Down", description: "Click any number to see the records behind it." },
        { title: "Export Anywhere", description: "Export to CSV or share a live link with your team." },
      ],
      image: "/assets/images/img/product/crm/reports-lead-image.webp",
      imageAlt: "Reports — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of CRM Analytics",
      description: "Reports connects to every other part of CRM Analytics in GetBiz CRM.",
    },
    cards: [
      { title: "Charts", href: "/crm-software/crm-analytics/charts/", description: "Turn any report into clear bar, line, pie or funnel charts so trends and outliers jump out instantly.", image: "/assets/images/img/product/crm/charts.webp", imageAlt: "GetBiz CRM charts" },
      { title: "Cohorts", href: "/crm-software/crm-analytics/cohorts/", description: "Group leads and customers into cohorts to see how conversion, retention and value change across segments and time.", image: "/assets/images/img/product/crm/cohorts.webp", imageAlt: "GetBiz CRM cohorts" },
      { title: "KPIs", href: "/crm-software/crm-analytics/kpis/", description: "Set targets and monitor sales KPIs.", image: "/assets/images/img/product/crm/kpis.webp", imageAlt: "GetBiz CRM kpis" },
      { title: "Funnels", href: "/crm-software/crm-analytics/funnels/", description: "Visualize your pipeline as a funnel to find the stages where deals stall, so you know precisely where to improve.", image: "/assets/images/img/product/crm/Funnels.webp", imageAlt: "GetBiz CRM funnels" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Reports in action.",
    relatedBlogs: "static",
    metaKey: "crm-analytics-reports",
  },
  sections: [],
};
